import {
    BlurEvent,
    ChangeEvent,
    DataSourceMode,
    LookupModelSearchEvent, Snackbar, Table,
    TableRow,
    TableRowDisplayEvent,
    Textbox
} from "@mcleod/components";
import { AutogenLayoutTriumphPayAuditControl } from "./autogen/AutogenLayoutTriumphPayAuditControl";
import {StringUtil} from "@mcleod/core";

export class TriumphPayAuditControl extends AutogenLayoutTriumphPayAuditControl {
    onLoad(): void | Promise<void> {
        // this is a workaround, was seeing an odd "ghost row" that stuck around after deletes despite being removed from the db and redisplaying in the arch code
        this.tableFieldList.doOnRowDelete = (row: TableRow) => {
            this.sourceHubtranFieldList.search();
        }
    }

    doAfterSlideIn() {
        this.sourceHubtranFieldList.mode = DataSourceMode.UPDATE;
        this.sourceHubtranFieldList.search();
        this.sourceHubtranInterfaceCodes.mode = DataSourceMode.UPDATE;
        this.sourceHubtranInterfaceCodes.search();
    }

    textboxRdyBillNoninvDocTypesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.code_type = 'HUBT';
    }

    sourceHubtranControlAfterExecution() {
        this.sourceHubtranDocTypes.search();
    }

    tableFieldListOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxTableName = tableRow.findComponentById("textboxTableName") as Textbox;
        const textboxFieldName = tableRow.findComponentById("textboxFieldName") as Textbox;
        const textboxFilterFieldName = tableRow.findComponentById("textboxFilterFieldName") as Textbox;
        const textboxFilterFieldValue = tableRow.findComponentById("textboxFilterFieldValue") as Textbox;
        const textboxReferenceField = tableRow.findComponentById("textboxReferenceField") as Textbox;
        const switchIsActive = tableRow.findComponentById("switchSwitch1");
        const textboxTransactionType = tableRow.findComponentById("textboxHubtranTransType") as Textbox;

        if (tableRow === this.tableFieldList.quickAddRow) {
            textboxFieldName.enabled = false;
            textboxFilterFieldName.enabled = false;
            textboxFilterFieldValue.enabled = false;
            textboxReferenceField.enabled = false;

            textboxTransactionType.tooltip = "Type of data to be sent to TriumphPay Audit when additions or updates occur to this field";
            textboxTableName.tooltip = "Database table name for which changes should be sent to TriumphPay Audit";
            textboxFieldName.tooltip = "Database field name for which changes should be sent to TriumphPay Audit";
            textboxFilterFieldName.tooltip = "Database field name to use as filter for which changes should be sent to TriumphPay Audit";
            textboxFilterFieldValue.tooltip = "Database field value to use as filter for which changes should be sent to TriumphPay Audit";
            textboxReferenceField.tooltip = "Field used to find movements, orders or carriers from transactions";
            switchIsActive.tooltip = "Mark checkbox to indicate this field is active";
        }

        textboxTableName?.addChangeListener((event: ChangeEvent) => {
            this.setFieldTextboxState(event, textboxFieldName);
            this.setFieldTextboxState(event, textboxFilterFieldName);
            this.setFieldTextboxState(event, textboxFilterFieldValue);
            this.setFieldTextboxState(event, textboxReferenceField);
        })
        textboxFieldName?.addBeforeLookupModelSearchListener(this.tableNameFilter(textboxTableName));
        textboxFilterFieldName?.addBeforeLookupModelSearchListener(this.tableNameFilter(textboxTableName));
        textboxReferenceField?.addBeforeLookupModelSearchListener(this.tableNameFilter(textboxTableName));
    }

    tableNameFilter(textbox: Textbox) {
        return (event: LookupModelSearchEvent) => {
            event.filter.table_name = textbox.text;
        }
    }

    setFieldTextboxState(event: ChangeEvent, textbox: Textbox) {
        if (event.newValue && textbox) {
            textbox.enabled = true;
        } else if (textbox) {
            textbox.enabled = false;
            textbox.text = "";
        }
    }

    textboxDisplayValueOnBlur(event: BlurEvent) {
        const textbox = event.target as Textbox;
        const table = this.findComponentById("tableDocMappings") as Table;
        const errorMessage = "A field with this Mapped Value already exists. Please enter a unique Mapped Value.";
        if(event.changedWhileFocused && !StringUtil.isEmptyString(textbox.text)){
            this.checkForDuplicatedRows(textbox, table, errorMessage);
        }
    }
    checkForDuplicatedRows(textbox: Textbox,table: Table, errorMessage: string){
        const tableRow = TableRow.getContainingTableRow(textbox);
        const inputId = textbox.text.toLowerCase();
        const duplicateExists = table.rows.some((row: TableRow) => {
            return row !== tableRow && row.data.get("display_value")?.toLowerCase() === inputId;
        });
        if (duplicateExists) {
            Snackbar.showWarningSnackbar(errorMessage);
            textbox.text = "";
            textbox.focus();
        }
    }
}
